// Static data arrays voor select fields
// Deze komen uit de originele firestore-db.js

// Bureau: no preset values - text field only
export const bureauOptions = [
  { Name: "Selecteer", Id: "" }
];

// Medium: based on GA4 standard medium types
export const mediumOptions = [
  { Name: "Selecteer", Id: "" },
  { Name: "Organic Search", Id: "organic_search" },
  { Name: "Paid Search (CPC)", Id: "cpc" },
  { Name: "Organic Social", Id: "organic_social" },
  { Name: "Paid Social", Id: "paid_social" },
  { Name: "Email", Id: "email" },
  { Name: "Display", Id: "display" },
  { Name: "Video", Id: "video" },
  { Name: "Affiliate", Id: "affiliate" },
  { Name: "Referral", Id: "referral" },
  { Name: "Direct", Id: "direct" },
  { Name: "Audio", Id: "audio" },
  { Name: "SMS", Id: "sms" },
  { Name: "Push", Id: "push" },
  { Name: "Native", Id: "native" }
];

// Titel: standard network/platform names
export const titelOptions = [
  { Name: "Selecteer", Id: "" },
  { Name: "Google", Id: "google" },
  { Name: "Facebook", Id: "facebook" },
  { Name: "Instagram", Id: "instagram" },
  { Name: "LinkedIn", Id: "linkedin" },
  { Name: "Twitter/X", Id: "twitter" },
  { Name: "YouTube", Id: "youtube" },
  { Name: "TikTok", Id: "tiktok" },
  { Name: "Snapchat", Id: "snapchat" },
  { Name: "Pinterest", Id: "pinterest" },
  { Name: "Reddit", Id: "reddit" },
  { Name: "WhatsApp", Id: "whatsapp" },
  { Name: "Spotify", Id: "spotify" },
  { Name: "DV360", Id: "dv360" },
  { Name: "Programmatic", Id: "programmatic" },
  { Name: "Newsletter", Id: "newsletter" }
];

// Doelgroep: based on attention/funnel phases
export const doelgroepOptions = [
  { Name: "Selecteer", Id: "" },
  { Name: "Awareness", Id: "awareness" },
  { Name: "Consideration", Id: "consideration" },
  { Name: "Conversion", Id: "conversion" },
  { Name: "Retention", Id: "retention" },
  { Name: "Advocacy", Id: "advocacy" },
  { Name: "Retargeting", Id: "retargeting" },
  { Name: "Lookalike", Id: "lookalike" },
  { Name: "Custom Audience", Id: "custom_aud" },
  { Name: "Cold Traffic", Id: "cold" },
  { Name: "Warm Traffic", Id: "warm" },
  { Name: "Hot Traffic", Id: "hot" }
];

// Uiting: creative/ad format types (inspired by original list)
export const uitingOptions = [
  { Name: "Selecteer", Id: "" },
  { Name: "Video", Id: "video" },
  { Name: "Image", Id: "image" },
  { Name: "Carousel", Id: "carousel" },
  { Name: "Collection", Id: "collection" },
  { Name: "Stories", Id: "stories" },
  { Name: "Reels", Id: "reels" },
  { Name: "Text Ad", Id: "text_ad" },
  { Name: "Display Banner", Id: "display_banner" },
  { Name: "Native Ad", Id: "native_ad" },
  { Name: "Audio Ad", Id: "audio_ad" },
  { Name: "Shopping Ad", Id: "shopping_ad" },
  { Name: "Lead Form", Id: "lead_form" },
  { Name: "Canvas", Id: "canvas" },
  { Name: "Playable Ad", Id: "playable_ad" },
  { Name: "Rich Media", Id: "rich_media" }
];

export const productgroupOptions = [
  { value: "", label: "Selecteer productgroep" },
  { value: "ev", label: "ev" },
  { value: "mf", label: "mf" },
  { value: "br", label: "br" },
  { value: "zb", label: "zb" },
  { value: "cl", label: "cl" },
  { value: "all", label: "all" }
];

export const customerjourneyOptions = [
  { value: "", label: "Selecteer customer journey" },
  { value: "awar", label: "awareness" },
  { value: "consi", label: "consideration" },
  { value: "purch", label: "purchase" },
  { value: "loya", label: "loyalty" },
  { value: "all", label: "all" }
];

export const landtaalOptions = [
  { value: "", label: "Selecteer land / taal" },
  { value: "nl_nl", label: "nl/nl" },
  { value: "be_nl", label: "be/nl" },
  { value: "be_fr", label: "be/fr" },
  { value: "be_de", label: "be/de" }
];

export const doelcampagneOptions = [
  { value: "", label: "Selecteer doel campagne" },
  { value: "touch", label: "touch" },
  { value: "tell", label: "tell" },
  { value: "sell", label: "sell" }
];

// Helper function to get default options for a field
export const getDefaultOptions = (fieldName) => {
  const optionsMap = {
    Bureau: bureauOptions,
    Medium: mediumOptions,
    Titel: titelOptions,
    Doelgroep: doelgroepOptions,
    Uiting: uitingOptions
  };
  return optionsMap[fieldName] || [];
};

